var DEFAULT_REFRESH_LEAD_TIME_MS = 60000;
export var resolveAccessTokenRefreshDelay = function(expiresAtValue) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), leadTimeMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : DEFAULT_REFRESH_LEAD_TIME_MS;
    if (expiresAtValue === null || expiresAtValue === undefined || expiresAtValue === '') {
        return null;
    }
    var expiresAt = typeof expiresAtValue === 'number' ? expiresAtValue : Number(expiresAtValue);
    if (!Number.isFinite(expiresAt) || expiresAt <= 0) {
        return null;
    }
    return Math.max(expiresAt - now - Math.max(leadTimeMs, 0), 0);
};
